<template>
  <div class="page">
    <headers :show="show" :activeIndex="3"></headers>
    <!-- 常见问题 -->
    <div class="commonProblem">常见问题</div>
    <!-- 常见问题内容 -->
    <div class="problem">
      <div @click="meiyou()" class="hover-gesture">没有账号？</div>
      <div @click="zhichi()" class="hover-gesture">支持的详细平台</div>
      <div @click="tuwen()" class="hover-gesture">图文新手教程</div>
      <div @click="teamEdition()" class="hover-gesture">团队版如何使用？</div>
    </div>
    <!-- 视频教程 -->
    <div class="videoTutorial">视频教程</div>
    <div class="introductionTutorial">入门教程</div>
    <!-- 入门教程视频 -->
    <div class="tutorialVideosInTotal">
      <div class="video1" @click="openVideo(config.addAccount)">
        <img
          src="@/assets/Group 90.png"
          alt="example image"
          style="cursor: pointer"
        />
        <div>怎么添加账号,设置分组</div>
      </div>
      <div class="video1" @click="openVideo(config.postArticle)">
        <img
          src="@/assets/Group 91.png"
          alt="example image"
          style="cursor: pointer"
        />
        <div>怎么发文章</div>
      </div>
      <div class="video1" @click="openVideo(config.postVideo)">
        <img
          src="@/assets/Group 92.png"
          alt="example image"
          style="cursor: pointer"
        />
        <div>怎么发视频</div>
      </div>
    </div>

    <div class="tutorialVideosInTotal2">
      <div class="video1" @click="openVideo(config.publishingContent)">
        <img
          src="@/assets/Group 93.png"
          alt="example image"
          style="cursor: pointer"
        />
        <div>内容发布小技巧</div>
      </div>
      <div class="video1" @click="openVideo(config.helper)">
        <img
          src="@/assets/Group 94.png"
          alt="example image"
          style="cursor: pointer"
        />
        <div>如何让助手记录你的设置</div>
      </div>
      <div class="video1" @click="openVideo(config.teamManagement)">
        <img
          src="@/assets/Group 95.png"
          alt="example image"
          style="cursor: pointer"
        />
        <div>怎么进行团队管理</div>
      </div>
    </div>

    <!-- 弹窗 -->
    <div v-if="isVideoOpen" class="video-modal">
      <div class="video-content">
        <video controls autoplay muted>
          <source :src="currentVideo" type="video/mp4" />
          Your browser does not support the video tag.
        </video>

        <button @click="closeVideo">关闭</button>
      </div>
    </div>

    <footers></footers>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { useConfigStore } from "@/store/index";
import footers from "../router/components/footer/footer.vue";
import headers from "../router/components/header/header.vue";

const router = useRouter();
const config = useConfigStore();
const isVideoOpen = ref(false);
const currentVideo = ref("");

const meiyou = () => {
  router.push({ name: "noAccount" });
};

const zhichi = () => {
  router.push({ name: "supportPlatform" });
};

const tuwen = () => {
  router.push({ name: "tutorial" });
};

const teamEdition = () => {
  router.push({ name: "teamEdition" });
};
const openVideo = (videoSrc) => {
  currentVideo.value = videoSrc;
  isVideoOpen.value = true;
};

const closeVideo = () => {
  isVideoOpen.value = false;
};
</script>

<style lang="less" scoped>
.page {
  .header {
    height: 100px;
    background: #ffffff;
    box-shadow: inset 0px -1px 0px 0px rgba(0, 0, 0, 0.1);
    border-radius: 0px 0px 0px 0px;
    display: flex;
    align-items: center;

    .lv {
      padding-left: 386px;
      width: 144px;
      height: 54px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 500;
      font-size: 36px;
      color: #333333;
      line-height: 42px;
      text-align: left;
      font-style: normal;
      text-transform: none;
      margin-right: 96px;
    }

    .navigation {
      display: flex;
      gap: 60px;
      height: 27px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 18px;
      color: #666666;
      line-height: 21px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .client {
      width: 100px;
      height: 36px;
      background: #6358ed;
      border-radius: 4px 4px 4px 4px;
      color: white;
      text-align: center;
      line-height: 36px;
      margin-left: 161px;
    }
  }

  // 常见问题
  .commonProblem {
    width: 128px;
    height: 48px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    line-height: 38px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: 0 auto;
    margin-top: 60px;
  }

  .problem {
    margin-top: 50px;
    display: flex;
    gap: 40px;
    justify-content: center;
  }

  .problem div {
    width: 270px;
    height: 60px;
    background: #ffffff;
    border-radius: 12px 12px 12px 12px;
    border: 1px solid rgba(99, 88, 237, 0.5);
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 20px;
    color: #6358ed;
    line-height: 23px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    line-height: 60px;
  }

  // 视频
  .videoTutorial {
    width: 128px;
    height: 48px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: bold;
    font-size: 32px;
    color: #333333;
    line-height: 38px;
    text-align: center;
    font-style: normal;
    text-transform: none;
    margin: auto;
    margin-top: 60px;
  }

  .introductionTutorial {
    background: #ffffff;
    border-radius: 0px 0px 0px 0px;
    margin-top: 40px;
    margin-left: 410px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 500;
    font-size: 24px;
    color: #333333;
    line-height: 28px;
    font-style: normal;
    text-transform: none;
  }

  .tutorialVideosInTotal {
    display: flex;
    gap: 39px;
    justify-content: center;
    margin-top: 20px;

    .video1 {
      width: 374px;
      height: 212px;
      border-radius: 0px 0px 0px 0px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 0px 0px 0px 0px;
      }

      div {
        text-align: center;
        margin-top: 16px;
      }
    }
  }

  .tutorialVideosInTotal2 {
    padding-bottom: 150px;

    display: flex;
    gap: 39px;
    justify-content: center;
    margin-top: 80px;

    .video1 {
      width: 374px;
      height: 212px;
      border-radius: 0px 0px 0px 0px;

      img {
        width: 100%;
        height: 100%;
        border-radius: 0px 0px 0px 0px;
      }

      div {
        text-align: center;
        margin-top: 16px;
      }
    }
  }

  .tail {
    margin-top: 120px;

    height: 120px;
    background: #6358ed;
    border-radius: 0px 0px 0px 0px;
    display: flex;
    align-items: center;

    .tailfontsize {
      padding-left: 138px;
      width: 682px;
      height: 30px;
      font-family: Source Han Sans CN, Source Han Sans CN;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      line-height: 23px;
      text-align: left;
      font-style: normal;
      text-transform: none;
    }

    .taildownload {
      margin-left: 376px;
      width: 142px;
      height: 48px;
      background: #ffffff;
      border-radius: 4px 4px 4px 4px;
      text-align: center;
      line-height: 48px;
    }
  }

  .footer {
    background: #333333;

    .zopng {
      .db {
      }

      .llo {
        width: 60px;
        height: 120px;
        border-radius: 0px 0px 0px 0px;
        border: 1px solid white;
      }

      .greenRoseDistribution {
        .tlos {
          .llo {
            margin: 0 auto;
          }

          .lvff {
            margin-top: 20px;
            width: 160px;
            height: 60px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: bold;
            font-size: 40px;
            color: #ffffff;
            line-height: 47px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }

          .lks {
            height: 24px;
            font-family: Source Han Sans CN, Source Han Sans CN;
            font-weight: 400;
            font-size: 16px;
            color: #ffffff;
            line-height: 19px;
            letter-spacing: 4px;
            text-align: center;
            font-style: normal;
            text-transform: none;
          }
        }
      }

      height: 350px;
      background: #333333;
      border-radius: 0px 0px 0px 0px;
      display: flex;
      padding-left: 210px;
      padding-top: 80px;

      .contactUs1 {
        padding-left: 173px;
        display: flex;
        gap: 50px;

        .vo {
          width: 110px;
          height: 110px;
          border-radius: 0px 0px 0px 0px;
          border: 1px solid white;
        }
      }

      .lv {
        display: flex;
        gap: 143px;

        .moreContent {
          padding-left: 107px;
        }

        .gd {
          width: 80px;
          height: 30px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 500;
          font-size: 20px;
          color: #ffffff;
          line-height: 23px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }

        .im {
          margin-top: 24px;
          display: flex;
          flex-direction: column;
          gap: 24px;

          height: 21px;
          font-family: Source Han Sans CN, Source Han Sans CN;
          font-weight: 400;
          font-size: 14px;
          color: #ffffff;
          line-height: 16px;
          text-align: left;
          font-style: normal;
          text-transform: none;
        }
      }
    }
  }

  .Copyright {
    height: 18px;
    font-family: Source Han Sans CN, Source Han Sans CN;
    font-weight: 400;
    font-size: 12px;
    color: #ffffff;
    line-height: 14px;
    text-align: center;
    margin: 0 auto;
    padding-bottom: 25px;
  }
}
</style>
